<template>
  <div class="unavailable-container">
    <div class="icon"><i class="fas fa-hourglass-half"></i></div>
    <span class="tip">抱歉，暂未开放，敬请期待... 😊</span>
  </div>
</template>

<script>
export default {
  name: 'Unavailable',
}
</script>

<style scoped lang="scss">
.unavailable-container {
  width: 300px;
  margin: 0 auto;
  margin-top: 150px;
  .icon {
    font-size: 100px;
    color: #E6A23C;
  }
  .tip {
    display: block;
    margin: 20px 0;
    color: #E6A23C;
  }
  
}
</style>
